import { createElementFromHTML } from '../../js/helper';
import { Overlay } from '../../components/overlay/overlay';
import { AjaxLoader } from '../../js/ajax-loader';

class ProductSupportOverlay {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-product-support-overlay',
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$productSupportOverlayOpenLink = element;
        this.overlaySrc = this.$productSupportOverlayOpenLink.getAttribute('href');
        this.activeTabnavId = null;

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }
    }

    initialize () {
        if (this.overlaySrc) {
            this.setEvents();
        }
    }

    setEvents () {
        this.$productSupportOverlayOpenLink.addEventListener('click', (e) => {
            this._buildOverlay();

            e.preventDefault();
        });
    }

    callOverlay (link) {
        this.$productSupportOverlayOpenLink = link;
        this._buildOverlay();
    }

    _buildOverlay () {
        this.$productSupportOverlayOpenLink.classList.add('is--loading');
        if (this.$loader) {
            this.$productSupportOverlayOpenLink.appendChild(this.$loader);
        }

        const overlay = new Overlay({
            loader: this.settings.loader,
            contentClass: 'product-support-overlay',
            styleClass: 'has--blur'
        });

        this.result = new AjaxLoader(this.overlaySrc, {
            onSuccess: (resultText) => {
                const $result = createElementFromHTML(resultText);
                const $resultContent = createElementFromHTML($result.innerHTML);
                overlay.setContent($resultContent);
                overlay.checkContent();
                overlay.show();
                this.$productSupportOverlayOpenLink.classList.remove('is--loading');
                if (this.$loader) {
                    this.$loader.parentNode.removeChild(this.$loader);
                }

                const $overlaySliders = overlay.$overlayContent.querySelectorAll('[data-teaserlist="slider"]');
                if ($overlaySliders.length > 0) {
                    import('../../modules/teaser-list/teaser-list').then(({ TeaserList }) => {
                        for (let i = 0; i < $overlaySliders.length; i++) {
                            const $overlaySlider = $overlaySliders[i];

                            const overlaySliderAPI = new TeaserList($overlaySlider);
                            $overlaySlider.API = overlaySliderAPI;
                        }
                    });
                }

                const $imageZooms = overlay.$overlayContent.querySelectorAll('[data-imagezoom="root"]');
                if ($imageZooms.length > 0) {
                    import('../../components/image/image-zoom').then(({ ImageZoom }) => {
                        for (let i = 0; i < $imageZooms.length; i++) {
                            const $imageZoom = $imageZooms[i];
                            const imageZoomAPI = new ImageZoom($imageZoom, {
                                loader: this.settings.loader
                            });
                            $imageZoom.API = imageZoomAPI;
                        }
                    });
                }

                const $overlayScroller = overlay.$overlayContent.parentNode;
                this.setOverlayAnimations($overlayScroller);
                this.overlayScroller($overlayScroller);
                this.setTabNav($overlayScroller);
            }
        });
    }

    setOverlayAnimations (overlay) {
        const $inviews = overlay.querySelectorAll('[data-inview]');

        for (let i = 0; i < $inviews.length; i++) {
            const $inview = $inviews[i];
            const inviewTag = $inview.tagName.toLowerCase();
            let elementPosition = 0;
            if (inviewTag === 'section' || inviewTag === 'nav') {
                elementPosition = $inview.offsetTop;
            } else {
                let parentElement = $inview.closest('section');
                if (parentElement) {
                    elementPosition = parentElement.offsetTop;
                } else {
                    parentElement = $inview.closest('nav');

                    if (parentElement) {
                        elementPosition = parentElement.offsetTop;
                    }
                }
            }
            const overlayScrollTop = overlay.scrollTop;
            const overlayHeight = overlay.offsetHeight;
            const onScreen = elementPosition - overlayScrollTop;

            if (overlayHeight > onScreen) {
                $inview.classList.add('inview');
                if ($inview.classList.contains('animate-next')) {
                    $inviews[i + 1].classList.add('inview');
                }
            }
        }
    }

    setTabNav (overlay) {
        const $tabnavs = overlay.querySelectorAll('[data-tabnav="root"]');
        const $tabnavAnchors = overlay.querySelectorAll('[data-tabnav="anchor"]');

        if ($tabnavs.length > 0) {
            for (let i = 0; i < $tabnavs.length; i++) {
                const $tabnav = $tabnavs[i];
                const elementDimensions = $tabnav.getBoundingClientRect();
                const elementTop = elementDimensions.top;

                if (elementTop > 10) {
                    if ($tabnav.classList.contains('is--sticky')) {
                        $tabnav.classList.remove('is--sticky');
                    }
                } else {
                    $tabnav.classList.add('is--sticky');
                }
            }

            if ($tabnavAnchors.length > 0) {
                let currentActiveId = null;
                for (let i = 0; i < $tabnavAnchors.length; i++) {
                    const $anchor = $tabnavAnchors[i];
                    const elementDimensions = $anchor.getBoundingClientRect();
                    const elementTop = elementDimensions.top;

                    if (elementTop - window.innerHeight / 2 <= 0) {
                        currentActiveId = $anchor.getAttribute('id');
                    }
                }

                if (this.activeTabnavId !== currentActiveId) {
                    this.activeTabnavId = currentActiveId;
                    this.setActiveTabnav($tabnavs, this.activeTabnavId);
                }
            }
        }
    }

    setActiveTabnav ($tabnavs, id) {
        for (let i = 0; i < $tabnavs.length; i++) {
            const $currentTabnav = $tabnavs[i];
            if (!$currentTabnav.classList.contains('has--no-anchor-highlighting')) {
                const $currentTabnavScroller = $currentTabnav.querySelector('[data-tabnav="items"]');
                const $allItems = $currentTabnav.querySelectorAll('[data-tabnav="item"]');
                const $activeItem = $currentTabnav.querySelector('a[href="#' + id + '"]');

                for (let a = 0; a < $allItems.length; a++) {
                    const $currentItem = $allItems[a];

                    if ($currentItem === $activeItem) {
                        $currentItem.classList.add('is--active');
                        $currentTabnavScroller.scrollLeft = $currentItem.offsetLeft - $allItems[0].offsetLeft;
                    } else {
                        $currentItem.classList.remove('is--active');
                    }
                }
            }
        }
    }

    overlayScroller (overlay) {
        overlay.addEventListener('scroll', () => {
            this.setOverlayAnimations(overlay);
            this.setTabNav(overlay);
        });
    }
}

export { ProductSupportOverlay };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productSupportOverlayOpenLinks = $context.querySelectorAll('[data-product-support-overlay="open"]');

        if ($productSupportOverlayOpenLinks.length > 0) {
            for (let i = 0; i < $productSupportOverlayOpenLinks.length; i++) {
                const $openLink = new ProductSupportOverlay($productSupportOverlayOpenLinks[i], {
                    loader: window.OPTIONS.loader
                });
                $openLink.initialize();
            }
        }
    }
});
